// Inline loading / error status for async (data-source-backed) enum options.

export function OptionsStatus({ loading, error }: { loading: boolean; error: string | null }) {
  if (loading) {
    return (
      <div className="form-text" role="status">
        Loading options…
      </div>
    )
  }
  if (error) {
    return (
      <div className="text-danger small" role="alert">
        Failed to load options: {error}
      </div>
    )
  }
  return null
}
